import { FC, PropsWithChildren, useEffect } from 'react';
import { clsx } from 'clsx';
import { useTocContext } from '../../hooks/useTocContext';
import styles from './TocSection.module.scss';

interface TocSectionProps<TP = unknown> extends PropsWithChildren {
  listItemTitle: string;
  domId: string;
  Title?: FC<TP>;
  titleProps?: Partial<TP>;
}

export function TocSection<TP>({
  domId,
  listItemTitle,
  children,
  Title,
  titleProps
}: TocSectionProps<TP>) {
  const { registerItem } = useTocContext();

  useEffect(() => {
    registerItem({
      title: listItemTitle,
      domId
    });
  }, []);

  return (
    <section data-id={domId} className={clsx('flex-col toc-section', styles.tocSection)}>
      {Title ? (
        <div id={domId} className={clsx('mb-1 toc-section-title', styles.tocSectionTitle)}>
          <Title {...(titleProps as TP & JSX.IntrinsicAttributes)} />
        </div>
      ) : null}

      {children}
    </section>
  );
}
